var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSettingIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4202 13.6402L15.7952 8.91518C15.5843 8.70436 15.2982 8.58594 15 8.58594C14.7018 8.58594 14.4157 8.70436 14.2048 8.91518L8.57977 13.6402C8.4748 13.7444 8.39159 13.8684 8.33498 14.005C8.27836 14.1417 8.24948 14.2882 8.25001 14.4361V21.1861C8.25001 21.3353 8.30927 21.4784 8.41476 21.5839C8.52025 21.6894 8.66332 21.7486 8.81251 21.7486H21.1875C21.3367 21.7486 21.4798 21.6894 21.5853 21.5839C21.6907 21.4784 21.75 21.3353 21.75 21.1861V14.4361C21.7505 14.2882 21.7217 14.1417 21.665 14.005C21.6084 13.8684 21.5252 13.7444 21.4202 13.6402ZM20.625 20.6236H9.37501V14.4361L14.4211 10.1974C14.7558 9.91622 15.2442 9.91622 15.5789 10.1974L20.625 14.4361V20.6236Z",
    fill: "#616E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1646 14.1016C15.697 14.1016 15.282 14.28 15.0008 14.5867C14.7196 14.28 14.3046 14.1016 13.837 14.1016C13.4297 14.102 13.0393 14.2586 12.7513 14.537C12.4633 14.8154 12.3013 15.1928 12.3008 15.5865C12.3008 17.2141 14.7636 18.5146 14.8683 18.5693C14.909 18.5905 14.9546 18.6016 15.0008 18.6016C15.047 18.6016 15.0925 18.5905 15.1332 18.5693C15.238 18.5146 17.7008 17.2141 17.7008 15.5865C17.7003 15.1928 17.5383 14.8154 17.2503 14.537C16.9623 14.2586 16.5719 14.102 16.1646 14.1016Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSettingIcon5);
export default __webpack_public_path__ + "static/media/location_setting_icon5.0ad43181cc172adf04174d0cea9d609e.svg";
export { ForwardRef as ReactComponent };